
import { setUserProfile, trackNewUserRegistration } from '../../redux/actions/user';
import { AccountEvent, EventCategory, EventDefinition, EventsMap } from '../types';
import { acTrackVisitOnSetProfile } from './activecampaign';

const trackAccountRegistration: EventDefinition<any> = ({ payload }) => {
  const profile = payload.result.updateProfile.profile;
  return {
    event: AccountEvent.NewAccount,
    category: EventCategory.Account,
    action: 'register-account',
    label: profile.user_id,
  };
};

export const accountEventsMap: EventsMap = {
  [setUserProfile.type]: acTrackVisitOnSetProfile,
  [trackNewUserRegistration.done.type]: trackAccountRegistration,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/account.ts